module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix home"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('v-container', {
    staticClass: "home-content",
    attrs: {
      "fluid": ""
    }
  }, [_c('app-logo'), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "home-title"
  }, [_c('p', {
    attrs: {
      "id": "vthacksTitle"
    }
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "vthacksNum"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "vthacksDate"
    }
  }, [_vm._v("\n                    February 12th, 2017\n                ")]), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": "/register"
    }
  }, [_c('v-btn', {
    staticClass: "vt-submit-btn",
    attrs: {
      "ripple": {
        class: 'teal--text'
      },
      "round": ""
    }
  }, [_vm._v("Register")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seaweed-right"
  }, [_c('img', {
    staticClass: "right-seaweed",
    attrs: {
      "src": require("../assets/title-card-seaweed-right.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seaweed-left"
  }, [_c('img', {
    staticClass: "left-seaweed",
    attrs: {
      "src": require("../assets/title-card-seaweed-left.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70ad1058!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 85
// module chunks = 1